import React, { FC, memo, useMemo } from 'react';
import { TColorgateConfigurationValues } from '../../../types';
import { ConfigurationChanges, TABLE_COLUMNS } from '../../../constants';
import { DivApplyChanges, DivTable, DivTitleApply } from './styles';
import { DivTitle } from '../../../styles';
import FnDataTable from '../../../../../components/blocks/FnDataTable/index';
import { getModifiedValues } from '../../../utils';
import ModifiedFiled from '../../FormComponents/ModifiedField';

type TProps = {
  type: ConfigurationChanges;
  values: TColorgateConfigurationValues;
  initialValues: TColorgateConfigurationValues;
  sku: string;
};

const ApplyChanges: FC<TProps> = ({ type, values, initialValues, sku }) => {
  const data = useMemo(() => getModifiedValues(type, values, initialValues), [type, values, initialValues]);

  return data.length ? (
    <>
      <DivTitle>Modified fields:</DivTitle>
      <DivTable>
        <FnDataTable columns={TABLE_COLUMNS} data={data} />
      </DivTable>
      <DivApplyChanges>
        <DivTitleApply>Apply changes on:</DivTitleApply>
        <ModifiedFiled
          name={type === ConfigurationChanges.Blank ? 'blankModified' : 'decorationModified'}
          value={`Only this SKU (#${sku})`}
        />
      </DivApplyChanges>
    </>
  ) : (
    <DivTitleApply>No modified fields.</DivTitleApply>
  );
};

export default memo(ApplyChanges);
